var FacetId;
(function(FacetId) {
    FacetId[// we will only list FacetId's which have a special meaning and are used in our code
    // facets to render when no productType is selected (primary facets):
    "productType"] = "productType";
    FacetId["price"] = "price";
    FacetId["brand"] = "brand";
    FacetId[// facets which represent colors
    "lensColor"] = "lensColor";
    FacetId["frameColor"] = "frameColor";
    FacetId[// id to recognize the commercetools category-facet
    "categoryExternalId"] = "categoryExternalId";
    FacetId[// isOfferedWithPrescriptions in order to avoid show it on Frames
    "isOfferedWithPrescriptions"] = "isOfferedWithPrescriptions";
})(FacetId || (FacetId = {}));
const PrimaryFacets = {
    [FacetId.productType]: true,
    [FacetId.price]: true,
    [FacetId.brand]: true
};
function isFacetHidden(facet) {
    return facet.hidden === true;
}
function isFacetVisible(facet) {
    return !isFacetHidden(facet);
}
function isValidAlgoliaSearchConfig(obj) {
    return Object.values(obj).every(Boolean);
}

export { FacetId, PrimaryFacets, isFacetHidden, isFacetVisible, isValidAlgoliaSearchConfig };
//# sourceMappingURL=types.js.map
